export default function EditInfoIco() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2573 1.22793C11.7234 0.761842 12.3555 0.5 13.0147 0.5C13.3411 0.5 13.6643 0.564283 13.9658 0.689183C14.2673 0.814083 14.5413 0.99715 14.7721 1.22793C15.0028 1.45872 15.1859 1.7327 15.3108 2.03423C15.4358 2.33577 15.5 2.65895 15.5 2.98532C15.5 3.3117 15.4358 3.63488 15.3108 3.93642C15.1859 4.23795 15.0028 4.51193 14.7721 4.74272L13.8526 5.66222C13.5272 5.98766 12.9995 5.98766 12.6741 5.66222L10.3378 3.32595C10.0123 3.00052 10.0123 2.47287 10.3378 2.14744L11.2573 1.22793ZM9.15926 4.50447C8.83385 4.17902 8.30618 4.17902 7.98076 4.50447L2.17571 10.3095C1.64171 10.8435 1.26289 11.5126 1.07973 12.2452L0.524897 14.4646C0.453905 14.7485 0.537114 15.0489 0.744097 15.2559C0.95108 15.4629 1.25149 15.5461 1.53546 15.4751L3.75478 14.9202C4.48741 14.7372 5.1565 14.3583 5.69049 13.8243L11.4955 8.01925C11.821 7.69383 11.821 7.16617 11.4955 6.84075L9.15926 4.50447Z"
        fill="#7F56D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 14.6666C8 14.2063 8.37308 13.8333 8.83333 13.8333H14.6667C15.1269 13.8333 15.5 14.2063 15.5 14.6666C15.5 15.1268 15.1269 15.4999 14.6667 15.4999H8.83333C8.37308 15.4999 8 15.1268 8 14.6666Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
